export const business = {
  appName: 'CityBarber',
  companyName: 'CityBarber',
  supportEmail: 'contact@citybarber.mk',
  privacyEmail: 'contact@citybarber.mk',
  address: 'Your business address'
};
